import { InitPageStrict } from "../index";

class ReplenishmentTemplatesIndex {
  private readonly modalSelector = "#replenishment-template-edit-dialog";
  private readonly formSelector = "#replenishment_template_edit_form";
  private readonly exportModalSelector = "#replenishment-templates-export-dialog";
  private readonly processCatalogItemsModalSelector = "#replenishment-templates-process-catalog-items-dialog";
  private readonly processCatalogItemsFormSelector = "#replenishment_templates_process_catalog_items_form";

  constructor() {
    this.dismissFlashMessages();
    this.bindEvents();
  }

  private dismissFlashMessages(): void {
    setTimeout(() => {
      $(".alert.alert-success.fade.in, .alert.alert-warning.fade.in, .alert.alert-danger.fade.in").each(function () {
        $(this).fadeOut(300, function () {
          $(this).remove();
        });
      });
    }, 2000);
  }

  private bindEvents(): void {
    $(document).on("click", ".replenishment-template-edit-trigger", (e) => {
      e.preventDefault();
      e.stopPropagation();

      const $btn = $(e.currentTarget);
      const updateUrl =
        $btn.attr("data-update-url") ||
        $btn.attr("data-update_url") ||
        ($btn.data("updateUrl") as string | undefined) ||
        "";
      const title = ($btn.attr("data-title") || $btn.data("title") || "") as string;

      const formEl = document.getElementById("replenishment_template_edit_form") as HTMLFormElement | null;
      if (formEl && updateUrl) formEl.action = updateUrl;

      const inputEl = document.getElementById("replenishment_template_title") as HTMLInputElement | null;
      if (inputEl) inputEl.value = title || "";

      const autoUpdate = ($btn.attr("data-auto-update") || $btn.data("autoUpdate") || "0") as string;
      const autoUpdateEl = document.getElementById("replenishment_template_auto_update") as HTMLInputElement | null;
      if (autoUpdateEl) autoUpdateEl.checked = autoUpdate === "1";

      $(this.modalSelector).modal({ backdrop: "static", keyboard: false });
    });

    // Reset on close
    $(this.modalSelector).on("hidden.bs.modal", () => {
      const inputEl = document.getElementById("replenishment_template_title") as HTMLInputElement | null;
      if (inputEl) inputEl.value = "";

      const formEl = document.getElementById("replenishment_template_edit_form") as HTMLFormElement | null;
      if (formEl) formEl.reset();
    });

    // Export button
    $(document).on("click", ".export-button", (e) => {
      e.preventDefault();
      $(this.exportModalSelector).modal("show");
    });

    $(document).on("click", ".process-catalog-items-button", (e) => {
      e.preventDefault();
      $(this.processCatalogItemsModalSelector).modal("show");
    });

    $(document).on("submit", this.processCatalogItemsFormSelector, (e) => {
      $(e.currentTarget).find("button[type='submit']").prop("disabled", true);
    });
  }
}

export function LoadPage(): void {
  InitPageStrict("replenishment_templates index", () => {
    new ReplenishmentTemplatesIndex();
  });
}

